module.exports = __webpack_public_path__ + "img/dark-green-square-table-3.c347ca23.png";